/**
 * Cross-module X XWP-74 (CP §11, §15.20 bullet 2; XO-14, XD-224) — the band of a window opened by the
 * « nouvelle fenêtre » flow: « Fenêtre ouverte depuis « Nouvel achat ». » and the action « Retourner
 * vers la fenêtre précédente » (button + the global registry key Alt+W). The action focuses the source
 * window — the form there was never navigated away — and closes this one when it holds nothing
 * unsaved (XD-246); when the source is gone, one clear sentence replaces it (role="status"), nothing
 * navigates. Rendered at the top of <main> by the AppShell; nothing at all in an ordinary window.
 */
import * as React from "react";
import { Button } from "@/components/ui/Button";
import { Icon } from "@/components/ui/primitives";
import { useShortcuts } from "@/hooks/useShortcuts.js";
import { useFenetreSource } from "@/hooks/useFenetreSource.js";
import { GLOBAL_SHORTCUTS } from "@/config/shortcuts.config.js";
import { M_FENETRE } from "@/config/fenetre-source.messages.js";

const TOUCHE = GLOBAL_SHORTCUTS.find((b) => b.id === "RETOUR_FENETRE")?.key;

export function RetourFenetrePrecedente() {
  const { actif, etat, libelle, message, retourner } = useFenetreSource();
  useShortcuts("GLOBAL", { RETOUR_FENETRE: () => void retourner() }, { enabled: actif });
  if (!actif) return null;
  const ouverte = etat === "ouverte";
  return (
    <div className="pk-fenetre-source" role="region" aria-label={M_FENETRE.bandeauLabel} data-fenetre-source={etat}>
      <Icon name={ouverte ? "app-window" : "info"} size={18} aria-hidden="true" />
      <span className="pk-fenetre-source-texte" role="status" aria-live="polite">
        {message ?? M_FENETRE.bandeau(libelle)}
      </span>
      <Button
        variant={ouverte ? "primary" : "secondary"}
        size="sm"
        icon="arrow-left"
        shortcut={TOUCHE}
        aria-keyshortcuts="Alt+W"
        onClick={() => retourner()}
      >
        {M_FENETRE.retourner}
      </Button>
    </div>
  );
}

export default RetourFenetrePrecedente;
